import { marked } from 'marked';

const MarkdownText = ({ text }: { text?: string }) => {
  return (
    <div
      // TODO: Is this left margin correct for all desktop pages?
      className='wysiwyg-section blue-links'
      dangerouslySetInnerHTML={{ __html: marked(text ?? '') }}
    />
  );
};

export default MarkdownText;
